// extracted by mini-css-extract-plugin
export default {"selectedRecipient":"MedicalRequestFormRecipientField_selectedRecipient__6wh8A","clearRecipient":"MedicalRequestFormRecipientField_clearRecipient__WGisP"};